var map = {
	"./de-DE.js": "b49e",
	"./en-US.js": "296e",
	"./es-ES.js": "64f8",
	"./fr-FR.js": "3be5",
	"./index.js": "bf0f",
	"./ja-JP.js": "1564",
	"./ko-KR.js": "9e69f",
	"./pt-PT.js": "2a6c",
	"./vi-VN.js": "10fc",
	"./zh-CN.js": "2f6e",
	"./zh-TW.js": "144c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9118";